import type { AdminRole } from '@uit/shared/schemas/auth';
import { NavLink } from 'react-router-dom';
import s from './Sidebar.module.scss';

interface NavItem {
  label: string;
  path: string;
  roles: AdminRole[];
  // Owner capability gate (T-169) — margin/profitability surfaces. `roles` still
  // applies; ownerOnly narrows further to admins flagged is_owner.
  ownerOnly?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Resources', path: '/', roles: ['admin', 'onboarding_only'] },
  { label: 'Onboarding queue', path: '/onboarding', roles: ['admin', 'onboarding_only'] },
  { label: 'Billing', path: '/billing', roles: ['admin'] },
  { label: 'Referrals', path: '/referrals', roles: ['admin'] },
  { label: 'Clients', path: '/clients', roles: ['admin'] },
  { label: 'Vendors', path: '/vendors', roles: ['admin', 'onboarding_only'] },
  { label: 'Backfill', path: '/backfill', roles: ['admin'], ownerOnly: true },
  { label: 'Settings', path: '/settings', roles: ['admin'], ownerOnly: true },
];

interface SidebarProps {
  role: AdminRole;
  isOwner: boolean;
}

export function Sidebar({ role, isOwner }: SidebarProps) {
  const visible = NAV_ITEMS.filter(
    (item) => item.roles.includes(role) && (!item.ownerOnly || isOwner),
  );

  return (
    <aside className={s.sidebar}>
      <div className={s.brand}>ultimumIT</div>
      <nav>
        {visible.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) => `${s.link} ${isActive ? s.linkActive : ''}`}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
